import React from 'react'

export default function About() {
  return (
    <div className="condiv about">
      <h1 className="subtopic">About Me</h1>
      <img
        src="https://avatars.githubusercontent.com/u/47815596?v=4"
        alt="profile"
        className="profilepic"
      />

      <h3>Hi, I'm Kumneung</h3>
      <p>i want to be a backend developer</p>
    </div>
  )
}
